(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["trip-capture-form"] && !Shopify.designMode) return;
  try {
    (function () {
    var STORAGE_KEY = 'cbc_trip_capture_v1';

    function remember(state) {
      try {
        localStorage.setItem(STORAGE_KEY, JSON.stringify({ state: state, at: Date.now() }));
      } catch (_) {}
    }

    function init(root) {
      if (root.dataset.tripReady) return;
      root.dataset.tripReady = 'true';

      var form = root.querySelector('form');
      var tags = root.querySelector('[data-trip-tags]');
      var month = root.querySelector('[data-trip-month]');
      var baseTags = tags.value;
      var match = root.querySelector('[data-trip-match]');

      if (match && month) {
        var showMatch = function () {
          var hasEvent = !!match.querySelector('[data-match="event"]');
          var kind = '';
          if (month.value) {
            kind = hasEvent && month.value === match.dataset.eventMonth ? 'event' : 'private';
          }
          match.querySelectorAll('[data-match]').forEach(function (el) {
            el.hidden = el.dataset.match !== kind;
          });
        };
        month.addEventListener('change', showMatch);
        showMatch();
      }

      form.addEventListener('submit', function (e) {
        e.preventDefault();
        e.stopPropagation();
        tags.value = baseTags + (month.value ? ',trip-' + month.value : ',trip-unsure');

        root.querySelector('[data-trip-form-view]').hidden = true;
        root.querySelector('[data-trip-success-view]').hidden = false;
        remember('signed-up');
        document.dispatchEvent(new CustomEvent('trip-capture:signed-up'));

        fetch(form.action || window.location.pathname, {
          method: 'POST',
          body: new FormData(form),
        }).catch(function () {});
      });
    }

    function initAll() {
      document.querySelectorAll('[data-trip-capture]').forEach(init);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
